module.exports = __webpack_public_path__ + "static/media/apple_card.a47a677f.jpg";